import { Injectable } from '@angular/core';
 import { Http } from '@angular/http';
//  import { SQLite } from 'ionic-native';
 import { Constants } from '../config';
 import { CartManager } from '../cart-manager';
 import {Api} from '../api';
 import { SQLite, SQLiteObject } from '@ionic-native/sqlite';
// import { SQLite } from 'ionic-native';
// import { SQLite } from 'ionic-native';
import { Platform } from 'ionic-angular';
import {GVLogger} from "../../services/gv-logger";


 @Injectable()
 export class DatabaseProvider {
   //db = new SQLite();
   public static db1 : SQLiteObject;
   data1 : any;

   UUID = "";

   DATABASE = "adp.db";
   LOCATION = "default";
   CUSTOMERS = "customers";
   CATEGORIES = "categories";
   PRODUCTS = "products";
   ORDERS = "orders";
   ATTRIBUTES = "attibutes";
   RECORDSPERSET ="12";
   res1: any;

   constructor(public http: Http ,private cartManager:CartManager, private sqlite : SQLite, private platform:Platform,
               private gVLogger:GVLogger) {
     this.RECORDSPERSET = Constants.fetchCount;

     this.nameTables();

   }

   public openDatabase() {

    this.platform.ready().then(() => {

    //  alert("open database called");
     this.nameTables();
      this.sqlite.create({name: this.DATABASE, location: this.LOCATION}).then((db2: SQLiteObject)=>{
        DatabaseProvider.db1 = db2;
        // alert("database created...!!!" + "DB1 Object" + DatabaseProvider.db1);
     	// this.createAllTables();
      //  alert(this.UUID);
       this.nameTables();
    let query = "CREATE TABLE IF NOT EXISTS "+this.CUSTOMERS+" (id INTEGER PRIMARY KEY AUTOINCREMENT, customerid INT, name VARCHAR(50), phone VARCHAR(50), json TEXT)";
    DatabaseProvider.db1.executeSql(query, []).then(() => {
      //  alert("CUSTOMERS table created");
      //  this.insertIntoCustomersValues();
         query = 'CREATE TABLE IF NOT EXISTS '+this.CATEGORIES+' (id  INTEGER PRIMARY KEY, json TEXT)';
         DatabaseProvider.db1.executeSql(query, [])
          .then((data) => {
              // alert("CATEGORIES table created");
              query = 'CREATE TABLE IF NOT EXISTS '+this.PRODUCTS+' (id INT, name VARCHAR(100), barcode VARCHAR(100),collectionid INT, subcollectionid INT, classid INT, json TEXT, description TEXT)';
              DatabaseProvider.db1.executeSql(query, [])
              .then(() => {
                  this.gVLogger.log("PRODUCTS table created");
                  query = 'CREATE TABLE IF NOT EXISTS '+this.ORDERS+' (id  INTEGER PRIMARY KEY, json TEXT)';
                  DatabaseProvider.db1.executeSql(query, []).then(() => {
                    this.gVLogger.log("PRODUCTS table created");
                    query = 'CREATE TABLE IF NOT EXISTS '+this.ATTRIBUTES+' (id  INTEGER PRIMARY KEY, json TEXT)';
                    DatabaseProvider.db1.executeSql(query, []).then(() => {
                       // alert("ATTRIBUTES table created");
                    },err=>{
                      // alert(JSON.stringify(err));
                    });
                   // alert("ORDERS table created");
                  },err=>{
                    // alert(JSON.stringify(err));
                  });
                },err=>{
                  // alert(JSON.stringify(err));
                })
              },err=>{
                // alert(JSON.stringify(err));
              })
     },err=>{
      //  alert(JSON.stringify(err));
    });
      }, (err) => {
        // alert("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! " + err);
        // this.gVLogger.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! " + err);
    });


  });
   }

   public createUserTable(){
     this.nameTables();
     let query = "CREATE TABLE IF NOT EXISTS user (id INTEGER PRIMARY KEY AUTOINCREMENT, firstname TEXT, lastname TEXT)";
     DatabaseProvider.db1.executeSql(query, []).then(() => {
       this.gVLogger.log("user table created");
     });
   }

   public insertIntoUser(user_details){
     this.nameTables();
     let insert_query = "INSERT INTO user VALUES (?, ?)";
     DatabaseProvider.db1.executeSql(insert_query, [user_details.first_name, user_details.last_name]).then((data) => {
       this.gVLogger.log("user inserted");
     });
   }


   public fetchFromUser(){
     this.nameTables();
     return DatabaseProvider.db1.executeSql('SELECT * FROM user', []);
   }


   public dropDatabase(){
     this.nameTables();
    this.sqlite.deleteDatabase({name: this.DATABASE, location: this.LOCATION});
  }




  // public createAllTables(){
  //   this.nameTables();
  //   let query = "CREATE TABLE IF NOT EXISTS "+this.CUSTOMERS+" (id INTEGER PRIMARY KEY AUTOINCREMENT, customerid INT, name VARCHAR(50), phone VARCHAR(50), json TEXT)";
  //    this.db1.executeSql(query, []).then(() => {
  //      this.gVLogger.log("CUSTOMERS table created");
  //        query = 'CREATE TABLE IF NOT EXISTS '+this.CATEGORIES+' (id  INTEGER PRIMARY KEY, json TEXT)';
  //        this.db1.executeSql(query, [])
  //         .then((data) => {
  //             this.gVLogger.log("CATEGORIES table created");
  //             query = 'CREATE TABLE IF NOT EXISTS '+this.PRODUCTS+' (id INT, name VARCHAR(100), barcode VARCHAR(100),collectionid INT, subcollectionid INT, classid INT, json TEXT,description TEXT)';
  //             this.db1.executeSql(query, [])
  //             .then(() => {
  //                 this.gVLogger.log("PRODUCTS table created");
  //                 query = 'CREATE TABLE IF NOT EXISTS '+this.ORDERS+' (id  INTEGER PRIMARY KEY, json TEXT)';
  //                 this.db1.executeSql(query, []).then(() => {this.gVLogger.log("ORDERS table created");},err=>{alert(JSON.stringify(err));});
  //               },err=>{alert(JSON.stringify(err));})
  //             },err=>{alert(JSON.stringify(err));})
  //    },err=>{alert(JSON.stringify(err));});
  // }




   public createCustomersTable(){
    //  alert("customer table separate function called");
     this.nameTables();
     let query = "CREATE TABLE IF NOT EXISTS "+this.CUSTOMERS+" (id INTEGER PRIMARY KEY AUTOINCREMENT, customerid INT, name VARCHAR(50), phone VARCHAR(50), json TEXT)";
     DatabaseProvider.db1.executeSql(query, []).then(() => {
      //  alert("customers table created");
     });
   }

   public insertIntoCustomersValues()
   {
    //  alert("insert called...!!!");
      this.nameTables();
//      this.gVLogger.log("customerssssss", this.CUSTOMERS);
  //    this.gVLogger.log("CATEGORIES", this.CATEGORIES);
    //  this.gVLogger.log("PRODUCTS", this.PRODUCTS);
      //this.gVLogger.log("ORDERS", this.ORDERS);
      //()";
      let insert_query = "INSERT INTO " + this.CUSTOMERS + "(customerid, name, phone, json) VALUES (?, ?, ?, ?)";
      //return this.db1.executeSql(insert_query);
      //customer.id, customer.name, customer.phone, customer.json
          DatabaseProvider.db1.executeSql(insert_query, [1, "Umar", "4324343", "object json"]).then((res) => {
            // alert("Rows inserted in sqlite database : " + res.rowsAffected);
          },err=> {alert("error while inserting data in database" + JSON.stringify(err));})

      // return DatabaseProvider.db1.executeSql(insert_query, [customer.id, customer.name, customer.phone, JSON.stringify(customer)]);
  }

   public insertIntoCustomers(customer)
   {
      this.nameTables();
    //  alert("customerssssss" +  this.CUSTOMERS);
  //    this.gVLogger.log("CATEGORIES", this.CATEGORIES);
    //  this.gVLogger.log("PRODUCTS", this.PRODUCTS);
      //this.gVLogger.log("ORDERS", this.ORDERS);
      //()";
      let insert_query = "INSERT INTO " + this.CUSTOMERS + "(customerid, name, phone, json) VALUES (?, ?, ?, ?)";
      //return this.db1.executeSql(insert_query);
      //customer.id, customer.name, customer.phone, customer.json
        return  DatabaseProvider.db1.executeSql(insert_query, [customer.id, customer.name, customer.phone, JSON.stringify(customer)]);
          // .then((res) => {
          //   alert("Rows inserted in sqlite database : " + res.rowsAffected);
          // },err=> {alert("error while inserting data in database" + JSON.stringify(err));})

      // return DatabaseProvider.db1.executeSql(insert_query, [customer.id, customer.name, customer.phone, JSON.stringify(customer)]);
  }


 	public fetchFromCustomers(){
     this.nameTables();
     return DatabaseProvider.db1.executeSql('SELECT * FROM '+this.CUSTOMERS, []);
   }

  //  public databaseStructure()
  //  {
  //    return DatabaseProvider.db1.executeSql("SHOW TABLES");
  //  }

   public truncateCustomersTable(){
     this.nameTables();

     return DatabaseProvider.db1.executeSql('DELETE FROM '+this.CUSTOMERS, []);
   }
   public truncateProductsTable(){
     this.nameTables();
     return DatabaseProvider.db1.executeSql('DELETE FROM '+this.PRODUCTS, []);
   }
   public truncateCategoriesTable(){
     this.nameTables();
     return DatabaseProvider.db1.executeSql('DELETE FROM '+this.CATEGORIES, []);
   }


   searchCustomers(q,offset)
    {
      // alert("search customers called...!!!");
      this.nameTables();
        q = '%' + q + '%';

        // alert ( "q: " + q + "offset : " + offset);

        // this.sqlite.create({name: this.DATABASE, location: this.LOCATION}).then((db : SQLiteObject) => {
        return  DatabaseProvider.db1.executeSql("SELECT * FROM " + this.CUSTOMERS + "", []);
        // },err=> {alert("error while creating database" + err);})
        // return DatabaseProvider.db1.executeSql("SELECT * FROM " + this.CUSTOMERS + "", []);
    //  return DatabaseProvider.db1.executeSql("SELECT * FROM "+this.CUSTOMERS+" WHERE name LIKE ? OR phone LIKE ? LIMIT 12 OFFSET ?", [q, q,offset]);
    }


//    searchCustomers(q,offset)
//     {
//       alert("search customers called...!!!");
//       this.nameTables();
//         q = '%' + q + '%';

//         alert ( "q: " + q + "offset : " + offset);
//         // this.gVLogger.log("QUERY.>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>"+"SELECT * FROM "+this.CUSTOMERS+" WHERE name LIKE ? OR phone LIKE ? LIMIT 12 OFFSET ?", [q, q,offset]);
//         // this.openDatabase();
//         return this.sqlite.create({name: this.DATABASE, location: this.LOCATION}).then((db2: SQLiteObject)=>{
//          db2.executeSql("SELECT * FROM " + this.CUSTOMERS, [])
//         .then((data) =>{

//           this.data1 = data;
//           alert("RRRRRRRooooooWWWWWW length after fetching.... " + this.data1.rows.length);
//           // return data;
//         },err=>{alert("errror while fetching data" + err)}
//         );
//     //  return DatabaseProvider.db1.executeSql("SELECT * FROM "+this.CUSTOMERS+" WHERE name LIKE ? OR phone LIKE ? LIMIT 12 OFFSET ?", [q, q,offset]);
//   }, (err) => {
//     alert("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! " + err);
//     this.gVLogger.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! " + err);
// });
//     }


    getCustomerById(cid){
      this.nameTables();
      return DatabaseProvider.db1.executeSql('SELECT * FROM '+this.CUSTOMERS+' WHERE id= ?', [cid])
    }


    insertIntoCategories(json){
      this.nameTables();
      return DatabaseProvider.db1.executeSql('INSERT INTO '+this.CATEGORIES+' (json) VALUES (?)',  [json]);
    }

    getCategories()
    {
      this.nameTables();
        return DatabaseProvider.db1.executeSql('SELECT json FROM '+this.CATEGORIES, []);
    }

    insertProduct(id, name,description, barcode, collectionId, subCollectionId, classId, json ){
      this.nameTables();
      // alert("insert called...!!!!" + id + name + description +  barcode + collectionId + subCollectionId + classId + json );
      DatabaseProvider.db1.executeSql('INSERT INTO '+this.PRODUCTS+' (id, name, barcode, collectionid, subcollectionid, classid, json,description) VALUES (?, ?, ?, ?, ?, ?, ?, ?)',  [id, name, barcode, collectionId, subCollectionId, classId, json,description])
      .then((res) => {
        // alert("Rows inserted in sqlite database : " + res.rowsAffected);
      })
    }

   insertAttributes(json ){
     this.nameTables();
     // alert("insert called...!!!!" + id + name + description +  barcode + collectionId + subCollectionId + classId + json );
     DatabaseProvider.db1.executeSql('INSERT INTO '+this.ATTRIBUTES+' (json) VALUES ( ?)',  [ json])
       .then((res) => {
         // alert("Rows inserted in sqlite database : " + res.rowsAffected);
       })
   }


    getAllCustomers(){
      this.nameTables();
      return DatabaseProvider.db1.executeSql('SELECT * FROM '+this.CUSTOMERS, []);
    }


    getAllProducts(){
      this.nameTables();
      return DatabaseProvider.db1.executeSql('SELECT * FROM '+this.PRODUCTS, []);
    }

   getAttributes(){
     this.nameTables();
     return DatabaseProvider.db1.executeSql('SELECT * FROM '+this.ATTRIBUTES, []);
   }

    getProductsByLazyLoad(collectionIds, subCollectionIds, classIds, offset) {

        this.nameTables();
        return DatabaseProvider.db1.executeSql('SELECT json FROM '+this.PRODUCTS+' WHERE collectionId IN (?) AND subcollectionId IN (?) AND classId IN (?) LIMIT ? OFFSET ?', [collectionIds, subCollectionIds, classIds, this.RECORDSPERSET, offset]);

    }


    getProductsByLazyLoadNew(collectionIds, subCollectionIds, classIds, offset,searchQuery) {

      // alert("search query in offline" + searchQuery);

                this.nameTables();
                let params:any = [];
                let query = "";
                let andflag = false;


                let searchFilter = "";

                if(searchQuery === " " || searchQuery === "%20" ){
                  // do nothing
                }else{
                  let searchParams = searchQuery.split(" ");
                  for(let [i,sq] of searchParams.entries()){
                    searchFilter += " name like %"+ sq +"% or description like %"+sq+"% or barcode like %"+sq+"% ";
                    if(i != searchParams.length-1){
                      searchFilter += " or ";
                    }
                  }

                }


                if(collectionIds[0] == 0){
                  collectionIds=[]
                }
                if(subCollectionIds[0] == 0){
                  subCollectionIds=[]
                }
                if(classIds[0] == 0){
                  classIds=[]
                }

               /* if(collectionIds.length>0)
                {
                    params[0] = collectionIds;
                    params[1] = subCollectionIds;
                    params[2] = classIds;
                    params[3] = this.RECORDSPERSET;
                    params[4] = offset;
                    query = "SELECT json FROM `products` WHERE collectionId IN (?) AND subcollectionId IN (?) AND classId IN (?) LIMIT ? OFFSET ?";
                }
                else if(subCollectionIds.length>0)
                {

                }
                else if(classIds.length>0)
                {

                }
                else
                {
                    params[0] = subCollectionIds;
                    params[1] = classIds;
                    params[2] = this.RECORDSPERSET;
                    params[3] = offset;

                    query = "SELECT json FROM `products` WHERE subcollectionId IN (?) AND classId IN (?) LIMIT ? OFFSET ?";
                }*/

                if(collectionIds.length>0)
                {
                    andflag = true;
                    //params.push(collectionIds);

                    var ids = "";
                    for(var i=0; i<collectionIds.length; i++){
                      if(i==0){
                        ids = ids.concat(collectionIds[i]);
                      }else{
                        ids = ids.concat(","+collectionIds[i]);
                      }
                    }

                    query = query + "WHERE collectionId IN ("+ids+")";
                }

                if(subCollectionIds.length>0)
                {
                    if(andflag)
                        query = query + " AND ";
                    else
                    {
                        query = query + " WHERE ";
                        andflag = true;
                    }

                    var ids = "";
                    for(var i=0; i<subCollectionIds.length; i++){
                      if(i==0){
                        ids = ids.concat(subCollectionIds[i]);
                      }else{
                        ids = ids.concat(","+subCollectionIds[i]);
                      }
                    }

                    query = query + " subcollectionId IN ("+ids+")";
                   // params.push(subCollectionIds);
                }

                if(classIds.length>0)
                {
                    if(andflag)
                        query = query + " AND ";
                    else
                    {
                        query = query + " WHERE ";
                    }
                    var ids = "";
                    for(var i=0; i<classIds.length; i++){
                      if(i==0){
                        ids = ids.concat(classIds[i]);
                      }else{
                        ids = ids.concat(","+classIds[i]);
                      }
                    }
                    query = query + " classId IN ("+ids+")";
                   // params.push(classIds);
                }

                let finalQuery = "SELECT json FROM "+this.PRODUCTS+" "+ query + searchFilter+ " LIMIT ? OFFSET ?";
                params.push(this.RECORDSPERSET);
                params.push(offset);

              //  alert(finalQuery);
              //  alert(JSON.stringify(params));
                return DatabaseProvider.db1.executeSql(finalQuery, params)

    }

     getProductByBarcode(barcode)
    {
        this.nameTables();
        return DatabaseProvider.db1.executeSql('SELECT json FROM '+this.PRODUCTS+' WHERE barcode = ?', [barcode]);
    }


    searchProducts(q, offset)
    {
      this.nameTables();

            if(offset==null){
                offset = 0;
            }

           // this.api.toastMSG("offset: "+ offset);

            q = '%'+q+'%';
       return DatabaseProvider.db1.executeSql('SELECT json FROM '+this.PRODUCTS+' WHERE name LIKE ? OR barcode LIKE ? LIMIT ? OFFSET ?', [q, q, this.RECORDSPERSET, offset]);

     }




     insertOrder(json)
    {
      this.nameTables();
      return DatabaseProvider.db1.executeSql('INSERT INTO '+this.ORDERS+'(json) VALUES (?)',  [json]);

    }

    getAllOrders()
    {
      this.nameTables();
        return DatabaseProvider.db1.executeSql('SELECT json FROM '+this.ORDERS+' ', []);

    }

    getOrder()
    {
      this.nameTables();
        return new Promise((resolve, reject)=>{
          DatabaseProvider.db1.executeSql('SELECT * FROM '+this.ORDERS+' LIMIT 1', [])
                        .then(result => {
                            let newObject:any;
                            if(result.rows.length>0)
                            {
                                let json = JSON.parse(result.rows.item(0).json);
                                newObject = {"id":result.rows.item(0).id, "order":json};
                            }
                            resolve(newObject);
                        })
                        .catch(e => reject(e));
        });
    }

   deleteOrderById(id)
    {
      this.nameTables();
        return new Promise((resolve, reject)=>{
          DatabaseProvider.db1.executeSql('DELETE FROM '+this.ORDERS+' WHERE id=?', [id])
                        .then(result => {
                            resolve(result);
                        })
                        .catch(e => reject(e));
                })
    }



    nameTables(){
      this.UUID = this.cartManager.getADPCustomerUUID().replace(/-/g, "").substring(0,10);
      this.CUSTOMERS = "customers_" + this.UUID;
      this.CATEGORIES = "categories_" + this.UUID;
      this.PRODUCTS = "products_" + this.UUID;
      this.ORDERS = "orders_" + this.UUID;
    }

}



// WEBPACK FOOTER //
// ./src/providers/database/database.ts